define('waoffcanvas', ['jquery'], function ($) {

    var waoffcanvas = {
        docBody: $('body'),
        noScrollClass: 'js_noscroll',
        offCanvas: $('.offcanvas'),
        offCanvasClose: $('.offcanvas__close'),
        offCanvasSlideSubItem: $('.offcanvas__slide'),
        offCanvasSlideBack: $('.offcanvas__back'),
        openClass: "js_open",
        slideClass: "js_slide",
        open: function open(id) {
            this.offCanvas = $('.offcanvas#' + id);
            this.offCanvas.addClass(this.openClass);
            this.docBody.addClass(this.noScrollClass);
        },
        close: function close() {
            this.offCanvas.removeClass(this.openClass);
            this.docBody.removeClass(this.noScrollClass);
        },
        slideSubItemIn: function slideSubItemIn(e) {
            e.preventDefault();
            this.currentSubItem = $(e.currentTarget);
            this.currentSubItem.toggleClass(this.slideClass);
        },
        slideSubItemOut: function slideSubItemOut() {
            this.offCanvasSlideSubItem.removeClass(this.slideClass);
        },
        bindEvents: function bindEvents() {
            var _this = this;

            this.offCanvasClose.on('click', function () {
                return _this.close();
            });
            this.offCanvasSlideSubItem.on('click', function (e) {
                return _this.slideSubItemIn(e);
            });
            this.offCanvasSlideBack.on('click', function (e) {
                return _this.slideSubItemOut();
            });
        },
        init: function init() {
            this.bindEvents();
        }
    };

    window.waoffcanvas = waoffcanvas;
    return waoffcanvas;
});

